import React, { Fragment, useCallback } from "react";
import { noop } from "lodash";

import RegListItem from "@tvg/atomic-ui/_molecule/RegistrationListItem";

import HeaderRegistration from "../../_organism/HeaderRegistration";
import MessageBox from "../../_molecule/BetNotification";
import { infoOutline } from "../../_static/Icons/iconsDuotone";
import buildColor from "../../_static/ColorPalette";

import {
  OuterContainer,
  InnerContainer,
  InnerTitle,
  InnerInfo,
  InfoTitle,
  MobilePageWrapper,
  MessageBoxContainer
} from "./styled-components";
import { REGISTRATION_STEPS } from "../../_static/Constants/progressBar";

const RegularPageRegistrationTemplate = (props) => {
  const {
    children,
    device,
    brand,
    infoTitle,
    infoText,
    infoTitleLast4,
    infoTextLast4,
    innerTitle,
    handleBackButton,
    currentStep,
    msgBoxTitle = "",
    msgBoxDesc = "",
    isFullSsn,
    isSsn,
    isEditing,
    isAddress
  } = props;

  const renderMessageBox = useCallback(
    (showTopBorder) => (
      <Fragment>
        <MessageBox
          title={msgBoxTitle}
          titleIsBold={false}
          textFontSize="large"
          color={buildColor("blue_accent", "600")}
          colorBorder={buildColor("blue_accent", "200")}
          colorBackground={buildColor("blue_accent", "000")}
          colorList={[
            buildColor("blue_accent", "200"),
            buildColor("blue_accent", "600")
          ]}
          iconElement={infoOutline}
          showCloseButton={false}
          showRulesLink={false}
          useLargerWidth={false}
          hasTopBorder={showTopBorder}
        />
      </Fragment>
    ),
    [msgBoxTitle, msgBoxDesc, device]
  );

  const infoTextList = () => (
    <Fragment>
      <InfoTitle isFullSsn={isFullSsn} isSsn={isSsn} data-qa-label="info-title">
        {infoTitle}
      </InfoTitle>
      <RegListItem
        stepQaLabel="welcome-inner-info-mobile"
        title=""
        list={!!infoText && typeof infoText !== "string" ? infoText : []}
        isSsn={isSsn || isFullSsn}
      />
    </Fragment>
  );

  const infoTextListLast4 = () => (
    <Fragment>
      <InfoTitle
        isFullSsn={isFullSsn}
        isSsn={isSsn}
        data-qa-label="info-title-last-4"
      >
        {infoTitleLast4}
      </InfoTitle>
      <RegListItem
        stepQaLabel="welcome-inner-info-mobile-last-4"
        title=""
        list={
          !!infoTextLast4 && typeof infoTextLast4 !== "string"
            ? infoTextLast4
            : []
        }
        isSsn={isSsn}
      />
    </Fragment>
  );

  const isAutoAddressWithInfoText =
    !!infoText && currentStep === REGISTRATION_STEPS.AUTO_ADDRESS;

  return (
    <OuterContainer
      data-qa-label={`${currentStep.toLowerCase()}-outer-container`}
    >
      <HeaderRegistration
        device={device}
        brand={brand}
        currentStep={currentStep}
        handleBackButton={handleBackButton}
        innerTitle={innerTitle}
        isFullSsn={isFullSsn}
        isEditing={isEditing}
      />

      <InnerContainer
        data-qa-label={`${currentStep.toLowerCase()}-inner-container`}
        isFullSsn={isFullSsn}
        isSsn={isSsn}
        isEditing={isEditing}
      >
        {(isFullSsn || (isSsn && isEditing)) && device !== "mobile" && (
          <MessageBoxContainer
            className="desktop-message-box"
            data-qa-label="desktop-message-box"
          >
            {renderMessageBox(false)}
          </MessageBoxContainer>
        )}
        {device !== "mobile" && !isAddress && (
          <Fragment>
            <InnerTitle
              data-qa-label="welcome-inner-title"
              isFullSsn={isFullSsn}
              isSsn={isSsn}
              isEditing={isEditing}
              $isAutoAddressWithInfoText={isAutoAddressWithInfoText}
            >
              {innerTitle}
            </InnerTitle>
            {isAutoAddressWithInfoText && (
              <InnerInfo
                isFullSsn={isFullSsn}
                data-qa-label="welcome-inner-info-desktop"
              >
                {infoText}
              </InnerInfo>
            )}
          </Fragment>
        )}
        {(isSsn || isFullSsn) && device !== "mobile" && infoTextList()}
        {isSsn && device !== "mobile" && infoTextListLast4()}

        {device === "mobile" &&
          currentStep !== REGISTRATION_STEPS.ADDRESS &&
          (innerTitle || infoText) && (
            <MobilePageWrapper isSsn={isSsn}>
              {(isFullSsn || (isSsn && isEditing)) && (
                <MessageBoxContainer
                  className="mobile-message-box"
                  data-qa-label="mobile-message-box"
                  addBottomMargin={!!infoText}
                >
                  {renderMessageBox(false)}
                </MessageBoxContainer>
              )}
              <InnerTitle
                data-qa-label="welcome-inner-title"
                isFullSsn={isFullSsn}
              >
                {innerTitle}
              </InnerTitle>
              {!!infoText &&
                (typeof infoText === "string" ? (
                  <InnerInfo
                    isFullSsn={isFullSsn}
                    data-qa-label="welcome-inner-info-mobile"
                  >
                    {infoText}
                  </InnerInfo>
                ) : (
                  infoTextList()
                ))}
              {isSsn &&
                !!infoTextLast4 &&
                (typeof infoTextLast4 === "string" ? (
                  <InnerInfo data-qa-label="welcome-inner-info-mobile-last-4">
                    {infoTextLast4}
                  </InnerInfo>
                ) : (
                  infoTextListLast4()
                ))}
            </MobilePageWrapper>
          )}
        {children}
      </InnerContainer>
    </OuterContainer>
  );
};

RegularPageRegistrationTemplate.defaultProps = {
  device: "mobile",
  brand: "tvg",
  innerTitle: "",
  infoText: "",
  infoTitle: "",
  handleBackButton: noop,
  currentStep: "WELCOME",
  isFullSsn: false,
  isSsn: false,
  isAddress: false,
  disableBackButton: false,
  msgBoxTitle: "",
  msgBoxDesc: []
};

export default RegularPageRegistrationTemplate;
